export default "__VITE_ASSET__DNv7_9hS__"